import app from 'Cloud/Application/app';
import addDays from 'date-fns/addDays';
import isBefore from 'date-fns/isBefore';
import parseISO from 'date-fns/parseISO';
import store from 'lib/store';

class Promo {
    constructor(public key: string) {}

    isShown() {
        const value = store.get(`${app.user.getEmail()}|${this.key}`);
        const isDate = parseInt(value);

        return isDate ? isBefore(new Date(), parseISO(value)) : value;
    }

    markAsShown({ daysCount }: { daysCount?: number } = {}) {
        const value = daysCount ? addDays(new Date(), daysCount) : true;

        store.set(`${app.user.getEmail()}|${this.key}`, value);
    }

    isEnabled() {
        return !(app.user && app.user.isNewbie()) && !app.getParam('MOBILE_BROWSER') && !app.getParam('IS_AUTO_TEST_HIDE');
    }

    isShownUntillTime({ time }: { time: Date }) {
        const value = store.get(`${app.user.getEmail()}|${this.key}`);

        return time && value ? time < value : undefined;
    }
}

export default Promo;
